/* eslint-disable no-undef */
<template>
    <div style="width:100%">
        <pageHeader :showIndex="-1" ref="pageHead"></pageHeader>
        <div class="main">
            <crumbs :crumbs="crumbsText"></crumbs>
            <div class="up-section up-section2">
                <div class="clearfix">
                    <div class="course-img fl" @click="pauseVedio">
                        <div style="position:relative;float:left;top:60px;height:400px;width:100%;z-index:999;opacity:0.9">
                            <vue-baberrage
                                :isShow= "barrageIsShow"
                                :barrageList = "barrageList"
                                :loop = "barrageLoop"
                            >
                            </vue-baberrage>
                        </div>               
                        <video id="player-container-id" preload="auto" playsinline webkit-playsinline>
                        </video>
                        

                    </div>
                    <div class="fr course-detail">
                        <div class="storyList clearfix">
                            <div style="font-size:24px;font-weight:bold;line-height:36px;margin-bottom:12px; border-bottom:1px solid #CCC">Story List

                            </div>
                            <div class="story-item" v-for="(storyVedio,index) in storyVideoList" :key="storyVedio.storyId" @click="playVedio(index)">
                                <span :class="storyVedio.isPlaying?'color-red':'color-9'">
                                    {{index+1}}. {{storyVedio.storyName}}
                                </span>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div v-if="isShowQuestion" class="question-detail" id="questionOptons">
                    <h3>Please choose the right answer:</h3>
                    <ul style="margin-top:24px">

                        <li :style="option_a_style" class="question-item" @click="doAnswer('A')">A</li>
                        <li :style="option_b_style" class="question-item" @click="doAnswer('B')">B</li>
                        <li :style="option_c_style" class="question-item" @click="doAnswer('C')">C</li>
                    </ul>    

                   
                </div>
            </div>
            
        </div>
        <pageFooter></pageFooter>
    </div>
</template>

<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"
import Crumbs from '../crumbs/crumbs'
import { MESSAGE_TYPE } from 'vue-baberrage'
export default {
    components: {
        pageHeader,
        pageFooter,
        Crumbs
    },
    data(){
        return{
            userInfo:[],
            timer:'',
            top: 10,
            left: 20,
            hasInitPlayer: false,
            currentStory:{},
            storyIndex: -1,     //当前故事Index
            lectureId: -1,      //当前章节
            lectureIndex: -1,   //视频播放序号 
            storyVideoList:[],  //故事视频列表
            isShowQuestion: false,
            crumbsText:[ //面包屑导航
                {name:'课程',path:'/courseList'},
                {name:'学习课堂',path:''},
            ],
            vedioPlayer: null,      //播放视频
            
            isPlaying: false,
            sendContent: null,
            isJs: true,
            direction: 'default',
            option_a_style:{
                background: 'gray'
            },
            option_b_style:{
                background: 'gray'
            },
            option_c_style:{
                background: 'gray'
            },
            barrageIsShow: true,
            currentId : 0,
            barrageLoop: false,
            barrageList: []

        }
    },
    created(){

        this.lectureId = this.$route.params.lectureId;
        console.log("入口参数:"+this.lectureId);
        this.loadLectureStory();
            

    },

    mounted() {
      this.userInfo = JSON.parse(localStorage.userInfo);

      this.timer = setInterval(this.pushTanmu, 5000);
    },
    watch:{
         $route() {
            this.lectureId = this.$route.params.lectureId;

            this.loadLectureStory();
         }
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.vedioPlayer.dispose();
    },

    methods:{
        pushTanmu(){
            this.barrageList.push({
                id: ++this.currentId,
                avatar: localStorage.avatar,
                msg: this.userInfo.username,
                time: 5,
                type: MESSAGE_TYPE.NORMAL
            });
        },
        doAnswer(answer){
            if(this.currentStory){
                this.vedioPlayer.pause();

                this.option_a_style.background="gray";
                this.option_b_style.background="gray";
                this.option_c_style.background="gray";
                if(answer ==this.currentStory.rightAnswer){

                    this.audio = new Audio();
                    this.audio.src= "https://marry.playhai.com/sound/yes.mp3";

                    this.audio.play();

                    if(answer=="A"){
                        this.option_a_style.background="green";
                        
                    }else if(answer=="B"){
                        this.option_b_style.background="green";
                    }else{
                        this.option_c_style.background="green";
                    
                    }
                    console.log("your answer is right");
                }else{

                    this.audio = new Audio();
                    this.audio.src= "https://marry.playhai.com/sound/no.mp3";

                    this.audio.play();
                    if(answer=="A"){
                        this.option_a_style.background="black";
                    }else if(answer=="B"){
                        this.option_b_style.background="black";
                    }else{
                        this.option_c_style.background="black";
                    
                    }
                    console.log("your answer is wrong");
                }

                this.vedioPlayer.play();
            }

        },

        pauseVedio(){
            if(this.isPlaying){
                this.vedioPlayer.pause();
            }else{
                this.vedioPlayer.play();
            }
        },
        playNext(){
            
            if(this.storyIndex<this.storyVideoList.length-1){
                this.storyIndex = this.storyIndex+1;

                this.playVedio(this.storyIndex);
            }
        },
        playVedio(index){    
            this.isShowQuestion = false;  
        
            this.storyIndex = index;
            let hasFoundVedio = false;

            this.option_a_style.background="gray";
            this.option_b_style.background="gray";
            this.option_c_style.background="gray";
            

            if(this.storyIndex > -1){

                for(let i=0;i<this.storyVideoList.length;i++){

                    this.storyVideoList[i].isPlaying = false;
                    if(i==this.storyIndex){
                        hasFoundVedio = true;
                        this.storyVideoList[i].isPlaying = true;

                        this.currentStory = this.storyVideoList[this.storyIndex];
                    }
                }
                
            }

            if(this.currentStory.vedioType=='Q'){
                this.isShowQuestion = true;
            }
            if(hasFoundVedio){
                
                //alert(this.currentStory.vedioId);
                if (!this.hasInitPlayer) {
                    //alert("初始化");
                    // eslint-disable-next-line no-undef
                    //var self = this;
                    // eslint-disable-next-line no-undef
                    this.vedioPlayer =TCPlayer("player-container-id", {
                        fileID: this.currentStory.vedioId,
                        appID: '1301740460',
                        autoplay: true
                    });

                    this.vedioPlayer.on('ended', () => {
                        this.playNext();
                    });

                    this.vedioPlayer.on('pause', () => {
                        this.isPlaying = false;
                    });
                    
                    this.vedioPlayer.on('playing', () => {
                        this.isPlaying = true;
                    });
                    this.hasInitPlayer = true;
                }else{
                  
                    this.vedioPlayer.loadVideoByID({
                        fileID: this.currentStory.vedioId,
                        appID: '1301740460',
                        autoplay: true
                    });
                    
                }
                
            }
            

        },
        //加载章节故事视频列表
        loadLectureStory(){
            
            let queryParams={
                lectureId: this.lectureId,
                userId: localStorage.userId,
                token: localStorage.token
            }

            let apiUri = this.baseUrl()+"/mobile/tbCourse/getStorysByLecture";

            this.$http.post(apiUri, this.$qs.stringify(queryParams),
             {headers: { 'Content-Type': 'application/x-www-form-urlencoded'}}).then(function(res){
				
                let lectureList = res.data.data;
                console.log(lectureList);
                let _storyList = [];

                for(let i=0;i<lectureList.length;i++){
                    let storyInfo = {};
                    storyInfo.storyId = lectureList[i].id;
                    storyInfo.storyName = lectureList[i].storyName;
                    storyInfo.vedioId =lectureList[i].vedioOtherId;
                    storyInfo.videoUrl = lectureList[i].vedioUrl;
                    storyInfo.isPlaying = false;
                    storyInfo.vedioType = lectureList[i].storyType;
                    storyInfo.rightAnswer = lectureList[i].rightAnswer;
                    storyInfo.order = lectureList[i].storyOrder;
                    console.log("story Order："+lectureList[i].storyOrder)

                    _storyList.push(storyInfo);

                    this.storyIndex=0;
                }

                this.storyVideoList = _storyList;

                console.log(this.storyVideoList);
                console.log("the story size:"+this.storyVideoList.length)

                this.playVedio(this.storyIndex);

			}).catch(function (error) {
				console.log(error);
			});

        },
        
    },
    beforeRouteLeave(to, form, next) {
        this.vedioPlayer.dispose();
        next();
    },
    

    
}
</script>

<style scoped>
    #player-container-id{
        width: 100%;
        max-height:100%;
        height: 0;
        padding-top: 56.25%;
    }
    /*上面*/
    .up-section{
        width: 1200px;
        margin: 0 auto 22px;
        background: #fff;
        box-sizing: border-box;
        color: #999;
    }

    .up-section .question-detail{
        margin-top:20px;
        
        
    }

    .up-section .question-detail h3{
        margin-top:20px;
        width: 100%;
        
    }

    .up-section .question-detail img{
        width:200px;
        height:200px;
        
    }
    .color3{
    color: #333;
    }
    .color6{
    color: #666;
    }
    .color9{
    color: #999;
    }
    .color-red{
        color: #ff6060;
    }
    
    .up-section .course-img{
        overflow: hidden;
    }
    .up-section1 .course-img{
        width: 320px;
        /*height: 192px;*/
        margin-right: 30px;
    }
    .up-section .course-img.p20{
        padding:20px 0 20px 20px;
    }
    .up-section1 .course-img img{
        width: 100%;
        max-width: 100%;
    }
    .up-section2 .course-img{
        width: 776px;
        height: 436px;
    }
    .up-section2 .course-img img{
        width: 100%;
        max-width: 100%;
    }
    .up-section2 .picBigUrl{
        width:60%;

    }
    .up-section1 .course-detail{
        padding-top: 20px;
        width: 830px;
        /*height: 232px;*/
        box-sizing: border-box;
        
    }
    .up-section2 .course-detail{
        width: 330px;
        height: 436px;
        box-sizing: border-box;
        padding-top: 20px;
        
    }
    .up-section2 .course-detail ul li{
        margin-bottom: 37px;
        
    }
    .up-section2 .course-detail ul li:last-child{
        position: absolute;
        width: 100%;
        bottom:0;
        margin-bottom: 0;
    }
    .up-section .course-img img{
        min-height: 100%;
        min-width: 100%
    }
    .up-section h3,.up-section h4{
        font-weight: bold;
    }
    .up-section h3{
        font-size: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .up-section1 h3{
        margin-right: 40px;
        max-width: 450px;
    }
    .up-section2 h3{
        margin-right: 40px;
        max-width: 280px;
    }

    .question-detail{
        height: 120px;
    }
    .question-item{
        float: left;

        background-color: darkgray;
        display: inline-flexbox;
        list-style-type: none;
        margin-left: 60px;
        margin-right: 60px;
        width: 160px;
        height: 80px;
        opacity:0.7;
        font-size: 64px;

        text-align: center;
        vertical-align: middle;

        color:#ff6060;
        font-weight: 900;
        border-radius: 5px;
        cursor:pointer;
    }

    .question-item .hover{
        
        width: 180px;
        height: 100px;
       
    }
    .story-item{
        font-size: 24px;
        line-height: 28px;
        height: 48px;
        
    }
    .player-barrage{
        float:left;position: relative;z-index:999;top:10;left:10
    }
    .barrage-control {
        text-align: center;
        margin: 10px 0px;
    }
</style>